/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AppsLauncherProperties from 'DesignSystem/AppsLauncherProperties/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImageSeriesLauncherProps/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let tabSelectedImagesLauncherValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.images.launcher',
})
let tabSelectedImagesImageSeriesUuidValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.images.image_series_uuid',
})
  return (<React.Fragment
>
<AppsLauncherProperties
  viewPath={`${viewPath}/AppsLauncherProperties`}
 data="tab.selected.images.launcher"
 launcher={tabSelectedImagesLauncherValueData}
 data="tab.selected.images.image_series_uuid"
 resourceId={tabSelectedImagesImageSeriesUuidValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}